import { render, staticRenderFns } from "./RegularizationAdd.vue?vue&type=template&id=cd9ca9ae&"
import script from "./RegularizationAdd.vue?vue&type=script&lang=js&"
export * from "./RegularizationAdd.vue?vue&type=script&lang=js&"
import style0 from "./RegularizationAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports